// import { instanceOf } from "prop-types";

function isObject(obj) {
  return obj === Object(obj);
}

export class BaseRepository {
  protected entityIdName = 'id';

  constructor(private restResource) {
  }

  save(entity) {
    return this[this.isEntityNew(entity) ? 'create' : 'update'](entity);
  }

  create(entity) {
    const entityData = this.prepareEntityForRequest(entity);
    return this.resource().create(entityData)
      .then((res) => this.processResponse(res))
      .catch((error) => this.processError(error));
  }

  update(entity){
    if (this.isEntityNew(entity)) {
      return new Promise((resolve, reject) => reject(new Error('Repository#updarte(): Entity is new')));
    }
    const entityData = this.prepareEntityForRequest(entity);
    return this.resource(entity)
      .update(entityData)
      .then((res) => this.processResponse(res))
      .catch((error) => this.processError(error));
  }

  patch(entity) {
    if (this.isEntityNew(entity)) {
      return new Promise((resolve, reject) => reject(new Error('Repository#patch(): Entity is new')));
    }
    const entityData = this.prepareEntityForRequest(entity);
    return this.resource(entity)
      .patch(entityData)
      .then((res) => this.processResponse(res))
      .catch((error) => this.processError(error));
  }

  load(params = {}) {
    return this.resource().get(params)
      .then((res) => this.processResponse(res))
      .catch((error) => this.processError(error));
  }

  loadById(id, params?) {
    if (id == null) {
      return new Promise((resolve, reject) => reject(new Error('Repository#loadById(): id is undefined')));
    }
    return this.resource(id).get(params)
      .then((res) => this.processResponse(res))
      .catch((error) => this.processError(error));
  }

  delete(entity) {
    if (this.isEntityNew(entity)) {
      return new Promise((resolve, reject) => reject(new Error('Repository#delete(): you can not update a new entity')));
    }
    return this.resource(entity).delete()
      .then((res) => this.processResponse(res))
      .catch((error) => this.processError(error));
  }

  search(params) {
    const searchParams = this.resolveSearchParams(params);
    const requestBody = Object.assign({}, searchParams);
    return this.resource().get(requestBody)
      .then((res) => this.processResponse(res))
      .catch((error) => this.processError(error));
  }

  isEntityNew(entity) {
    return entity && entity[this.entityIdName] == null;
  }

  resource(...params) {
    if (!params || params.length === 0) {
      return this.restResource;
    } else if (params.length === 1) {
      return this.restResource.child(this.resolveResourceParamLiteral(params[0]));
    }

    const resourcePath = params.reduce((result, param, index) => {
      if (index !== 0) {
        result += '/';
      }
      result += this.resolveResourceParamLiteral(param);
      return result;
    }, '');

    return this.restResource.child(resourcePath);
  }

  prepareEntityForRequest(entity) {
    // if (this.DataMapper) {
    //   return this.DataMapper.decode(entity);
    // }
    return entity;
  }

  processError(error) {
    if (error instanceof Promise) {
      return error.then((errorObject) => {
        throw (errorObject);
      })
    }
    throw error;
  }

  async processResponse(response) {
    let result: any = { meta: null };
    let responseJson;
    try {
      responseJson = response && await response.json();
    } catch(e) {
      if (e === 'Unexpected end of JSON input') {
        responseJson = {};
      }
    }

    if (!responseJson) {
      return;
    }

    let data;
    let meta: any = null;

    if (responseJson.list && Array.isArray(responseJson.list)) {
      data = responseJson.list;
      meta = {
        page: responseJson.page,
        per_page: responseJson.size,
        total: responseJson.total_count
      };
    } else {
      data = responseJson;
    }

    if (Array.isArray(data)) {
      result = data.map((entityData) => this.encodeEntity(entityData));
    } else {
      result = this.encodeEntity(data);
    }

    result.meta = meta;

    return result;

  }

  /**
   * Private helpers methods
   */

  resolveResourceParamLiteral(param) {
    if (isObject(param)) {
      return param[this.entityIdName];
    }
    return param;
  }

  resolveSearchParams(params) {
    if (params) {
      const result = Object.assign({}, params);
      if (params.page) {
        result.page = Number(result.page);
      }
      if (params.per_page) {
        result.size = Number(result.per_page);
        delete result.per_page;
      }

      return result;
    }
    return {};
  }

  encodeEntity(entityData) {
    // if (this.DataMapper) {
    //   return this.DataMapper.encode(entityData);
    // }

    return entityData;
  }
}
